import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '@fullyops/data/base/configuration/api-service-config';
import { catchError, map, Observable, of } from 'rxjs';
import { MiniCompany } from './mini-company';
import { Company, CompanyAssignee, CompanyInput, CompanyType } from './company';

@Injectable({ providedIn: 'root' })
export class ApiCompaniesAdapterService {
  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getMini(type?: 'CLIENT' | 'SUPPLIER'): Observable<MiniCompany[]> {
    const url =
      this.config.url +
      'companies/names' +
      (type != null ? '?type=' + type : '');
    return this.http.get<MiniCompany[]>(url);
  }

  existsByNifAndType(nif: string, type: CompanyType): Observable<boolean> {
    return this.http
      .get<{}[]>(this.config.url + `companies/nif/${nif}/${type}`)
      .pipe(map((companies) => companies.length > 0));
  }

  getCompanies(params?): Observable<{ results: Company[] }> {
    return this.http.get<{ results: any[] }>(this.config.url + 'companies', {
      params: { ...params, page: -1 },
    });
  }

  getPotentialAssignees(): Observable<CompanyAssignee[]> {
    return this.http.get<CompanyAssignee[]>(this.config.url + 'users/names');
  }

  create(input: CompanyInput): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.config.url + 'companies', input);
  }
}
